import {
    OnlinePaymentStatus,
    POSPaymentStateStatus,
    SettlementsStatus,
    PaymentsStatus,
    PaymentsType
} from '@/constants'

export const ECOMTransactionStatuses = [
    OnlinePaymentStatus.charge,
    OnlinePaymentStatus.auth,
    OnlinePaymentStatus.reject,
    OnlinePaymentStatus.refund
]
export const POSTransactionStatuses = [
    POSPaymentStateStatus.all,
    POSPaymentStateStatus.successful,
    POSPaymentStateStatus.failed
]

export const SettlementsStatuses = [
    SettlementsStatus.sales,
    SettlementsStatus.refunds,
    SettlementsStatus.fees,
    SettlementsStatus.adjustments,
    SettlementsStatus.settlements
]

export const PaymentsStatuses = [
    PaymentsStatus.charged,
    PaymentsStatus.refunds,
    PaymentsStatus.pending
]

export const PaymentsTypes = [PaymentsType.all, PaymentsType.ecom, PaymentsType.pos]
